import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Form, FormAnswer, Patient, QuestionnaireState, Task } from '@app/types';

export interface RequestLinkPayload {
  token?: string;
  promId?: string;
}

export interface SetLinkPayload {
  patient: Patient;
  task: Task;
  form: Form;
}

const initialState: QuestionnaireState = {
  loading: true,
  status: null,
  patient: null,
  task: null,
  token: null,
  error: null,
  discarded: false,
  form: {},
  language: 'de'
};

const questionnaireSlice = createSlice({
  name: 'questionnaire',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    requestLink(state, action: PayloadAction<RequestLinkPayload>) {
      state.loading = true;
      state.error = null;
      state.token = action.payload.token ?? null;
    },
    setLink(state, action: PayloadAction<SetLinkPayload>) {
      const { patient, task, form } = action.payload;
      state.patient = patient;
      state.task = task;
      state.form = form;
    },
    setStatus(state, action: PayloadAction<string>) {
      state.status = action.payload as 'denied' | 'yes' | null;
    },
    setError(state, action: PayloadAction<boolean | string>) {
      state.error = action.payload;
    },
    setLanguage(state, action: PayloadAction<string>) {
      state.language = action.payload;
    },
    saveAnswers(state, action: PayloadAction<Record<string, string>>) {
      state.form.answers = { ...state.form.answers, ...action.payload } as FormAnswer[];
    },
    submitAnswers(state, _action: PayloadAction<{ incomplete?: boolean } | undefined>) {
      state.loading = true;
      state.discarded = false;
    },
    setActiveTab(state, action: PayloadAction<string>) {
      state.form.activeTab = action.payload;
    },
    setDiscarded(state, action: PayloadAction<boolean>) {
      state.discarded = action.payload;
    }
  }
});

export const {
  setLoading,
  setLink,
  requestLink,
  setStatus,
  setError,
  setLanguage,
  saveAnswers,
  submitAnswers,
  setActiveTab,
  setDiscarded
} = questionnaireSlice.actions;
export default questionnaireSlice.reducer;
